import { removeLoginCookie } from "components/LoginForm/LoginFormDao";

export const handleLogout = async (redirectUrl: any, navigate: any, setAuth: any) => {

  removeLoginCookie("setLoginCookie");
  localStorage.removeItem("bonusPopup");
  localStorage.removeItem("access_token");
  setAuth(null);

  if (redirectUrl) {
    window.location.replace(redirectUrl);
  } else {
    navigate("/");
  }
};